import { useRef, useEffect, useState } from "react";

import SignatureCanvas from "react-signature-canvas";
import { useTranslation } from "react-i18next";
const SignaturePad = ({
  signature,
  setSignature,
  url,
  setUrl,
  gotSignature,
  showRetryBtn = true,
  fixedSignatureCanvasWidth = 910,
  fixedSignatureCanvasHeight = 370,
}) => {
  const { t } = useTranslation();
  const canvasRef = useRef(null); // stores drawn signature

  // const [canvasWidth, setCanvasWidth] = useState(300); // Default width  ----
  // const [canvasHeight, setCanvasHeight] = useState(185); // Default height-------

  var inMemCanvas = document.createElement("canvas");
  var inMemCtx = inMemCanvas.getContext("2d");

  const clearSign = () => {
    if (canvasRef.current) canvasRef.current.clear();
    if (setUrl) setUrl(null);
  };

  const [dimensions, setDimensions] = useState({ width: 1, height: 1 });

  useEffect(() => {
    // Measure container size after mount

    if (canvasRef.current) {
      setTimeout(() => {
      const { width, height } = canvasRef.current.getCanvas().getBoundingClientRect();
      setDimensions({ width, height });
      }, 500);
    }
  }, []);

  return (
    <div>
      <div>
        <div className="signature-box">
          <SignatureCanvas
            key={"sigantureCanvasKiosk"}
            canvasProps={{
              width: dimensions.width,
              height: dimensions.height,
              // width: fixedSignatureCanvasWidth, // FIXED width
              // height: fixedSignatureCanvasHeight, // FIXED height
              className: "sigCanvas",
              style: { marginTop: "0px" },
            }}
            ref={(c) => {
              canvasRef.current = c;
              setSignature(c);
            }}
            onEnd={gotSignature}
          />
        </div>
        {/* <p className="sign-here">Sign Here</p> */}
      </div>
      {showRetryBtn && (
        <div className="d-flex justify-content-end" style={{ float: "right" }}>
          <button
            id="btn-signaturepad-retry"
            onClick={clearSign}
            className="btn terms-retry-btn"
          >
            <i className="bx bx-revision"></i>
            {t("Retry")}
          </button>
        </div>
      )}
      <div className="sign-here-line">
        <span>X</span>
        <span className="line"></span>
        {/* <span>Sign Here</span> */}
      </div>
    </div>
  );
};

export default SignaturePad;
